import { render, staticRenderFns } from "./EnrolmentQuestionProgramCountEditor.vue?vue&type=template&id=78e94b12&scoped=true"
import script from "./EnrolmentQuestionProgramCountEditor.vue?vue&type=script&lang=js"
export * from "./EnrolmentQuestionProgramCountEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e94b12",
  null
  
)

export default component.exports